import React from 'react'

import { ResolvedAIReviewSection } from 'src/pages/module-review/moduleAIReviewPages'
import { ModuleAIReview } from 'src/services/backend/ModuleAIReviewService'

export interface ModuleAIReviewContextProps {
    /** False when the feature is off or there is no review to analyse; consumers render nothing. */
    isEnabled: boolean
    aiReview?: ModuleAIReview
    /** Sections whose findings carry the module page they belong to. */
    sections: ResolvedAIReviewSection[]
    isLoading: boolean
    error?: Error
}

export const ModuleAIReviewContext = React.createContext<ModuleAIReviewContextProps>({
    isEnabled: false,
    sections: [],
    isLoading: false,
})
